import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        sites: '=',
        metaFieldGroups: '=',
        questionPools: '='
    },
    template: `
    <forms-questions-actions-update
        question="vm.question"
        back-to-list-with-params="'authorized.forms.questions.poolless.list'"
        form="vm.form"
        sites="vm.sites"
        question-pools="vm.questionPools"
        meta-field-groups="vm.metaFieldGroups"
    ></forms-questions-actions-update>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/poolless/question/index.js